export const LayoutsPageView = require('./LayoutsPageView').default;
export const LayoutsCreatePageView = require('./LayoutsCreatePageView').default;
export const LayoutsUpdatePageView = require('./LayoutsUpdatePageView').default;
